import { resetTimer, skipElement} from "./main";

var
  Player = {
  videoElem: null,    // tag video
  STATES: {
    STOPPED: 0,
    PLAYING: 1,
    PAUSED: 2,
    PREPARED: 4
  },
  state: 0,             // initial state: STOPPED
  phfcli : null,
  time : null
};

// Initialize player
Player.init = function (id, phfcli) {
  if(phfcli.debug == 1){
    console.log("Player.init(" + id + ")");
  }
  this.phfcli = phfcli;
  this.state = this.STATES.STOPPED;

  if (!this.videoElem && id) {
    this.videoElem = document.getElementById(id);
    // if (this.videoElem != null && this.videoElem != "") {
    //   this.videoElem.addEventListener('error', function () { /* Video playback failed: show a message saying why */
    //     switch (this.videoElem.error.code) {
    //       case 1:
    //         alert('MEDIA_ERR_ABORTED = 1 Media data download is stopped by the user');
    //         break;
    //       case 2:
    //         alert('MEDIA_ERR_NETWORK = 2 Download is stopped due to network error ');
    //         break;
    //       case 3:
    //         alert('MEDIA_ERR_DECODE = 3 Media data decoding failure ');
    //         break;
    //       case 4:
    //         alert('MEDIA_ERR_SRC_NOT_SUPPORTED = 4 Format not supported');
    //         break
    //     }
    //   }, false);
    // }
  }

  Player.setupEventListeners();
}

// Load video.
Player.prepare = function (url, time) {
  if(this.phfcli.debug == 1) {
    console.log("Player.prepare(" + url + ")");
  }

  this.time = time;

  if (this.state > this.STATES.STOPPED) {
    return;
  }

  if (!this.videoElem) {
    return 0;
  }

  this.videoElem.src = url;
  this.videoElem.load();
}

// Play video
Player.play = function () {

  // console.log("Player.play(" + url + ")");
  // var data =  new Date();
  // console.log('play slide' + data.getHours() + ":" + data.getMinutes()+ ":"+data.getSeconds());

  if (this.state < this.STATES.PAUSED) {
    return;
  }

  this.state = this.STATES.PLAYING;

  // if (url) {
  //   this.videoElem.src = url;
  // }
 //per gestire se funziona o no il play()
  var promise = this.videoElem.play();
  if (promise !== undefined) {
    promise.then(r => {
      // Autoplay started!
      if(this.phfcli.debug == 1) {
        (console.log("autoplay sterted correctly" + r));
      }
    }).catch(error => {
      // Autoplay was prevented.
      if(this.phfcli.debug == 1) {
        (console.log("error during play video" + error));
      }
      resetTimer(Player.time, Player.phfcli);
    });
  }
}

// Pause video
Player.pause = function () {
  if(this.phfcli.debug == 1) {
    console.log("Player.pause()");
  }

  if (this.state != this.STATES.PLAYING) {
    return;
  }

  this.state = this.STATES.STOPPED;

  this.videoElem.pause();

}

// Stop video
Player.stop = function () {
  if(this.phfcli.debug == 1) {
    console.log("Player.stop()");
  }
  var data =  new Date();
  if(this.phfcli.debug == 1) {
    console.log('Video stop slide' + data.getHours() + ":" + data.getMinutes() + ":" + data.getSeconds());
  }
  this.state = this.STATES.STOPPED;
  // this.videoElem.pause();
  if (this.videoElem.readyState > 0) {
    this.videoElem.src = "";
  }
}

// Set position and dimension of video area
Player.setDisplayArea = function (x, y, width, height) {

  if (!this.videoElem) {
    return 0;
  }

  this.videoElem.style.top = x + "px";
  this.videoElem.style.top = y + "px";
  this.videoElem.style.width = width + "px";
  this.videoElem.style.height = height + "px";
}

// format time in seconds to hh:mm:ss
Player.formatTime = function (seconds) {

  var hh = Math.floor(seconds / 3600),
    mm = Math.floor(seconds / 60) % 60,
    ss = Math.floor(seconds) % 60;

  return (hh ? (hh < 10 ? "0" : "") + hh + ":" : "") +
    ((mm < 10) ? "0" : "") + mm + ":" +
    ((ss < 10) ? "0" : "") + ss;
}

// Setup Listeners for video player events
Player.setupEventListeners = function () {

  if (!this.videoElem) {
    return 0;
  }

  var that = this;

  // triggered when video metadata was loaded, i.e. duration dimensions etc
  this.videoElem.addEventListener('loadedmetadata', function () {
      // console.log("Video metadata info was loaded");
    that.state = that.STATES.PREPARED;
    //document.getElementById("total-time").innerHTML = that.formatTime(that.videoElem.duration);
  }, false);

  // triggered when video has ended.
  this.videoElem.addEventListener('ended', function () {
      // console.log("Video ended");
    // that.state = that.STATES.PREPARED;
    Player.pause();
    resetTimer(0, Player.phfcli);
  }, false);

  // triggered when playing has changed
  this.videoElem.addEventListener('timeupdate', function () {
    var duration = that.videoElem.duration;
    if (duration > 0) {
      //document.getElementById('progress-amount').style.width = ((that.videoElem.currentTime / duration)*100) + "%";
      //document.getElementById("current-time").innerHTML = that.formatTime(that.videoElem.currentTime);
    }
  }, false);


  // triggered when the browser is in the process of getting the media data
  this.videoElem.addEventListener('progress', function () {
      // console.log("Buffering...");
  }, false);



  // triggered when a file is ready to start playing (when it has buffered enough to begin)
  this.videoElem.addEventListener('canplay', function () {
      // console.log('Buffering Complete, Can play now!');
    Player.play();
    // resetTimer(Player.time, Player.phfcli);
  }, false);

  // triggered when some error during video happens
  this.videoElem.addEventListener('error', function (e) {
      console.log("Some error had happened: " + e);
    skipElement(Player.phfcli);
  }, false);

}


if (!window.Player) {
  window.Player = Player;
}

// // setup video player
// Player.init("player");
// Player.prepare("https://content.fulsvc.com/temp1/robottino.mp4"); // <-- set video URL here!

export {Player}
